import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const findMatchFunction = httpsCallable(functions, 'findMatch');

const ADULT_AGE_GROUP = 'adult';

export async function findMatch(userId, veylData, veylId) {
  try {
    if (!veylData.goalCategory) {
      console.error('findMatch failed: missing goalCategory');
      return false;
    }

    const result = await findMatchFunction({
      userId,
      veylId,
      goalCategory: veylData.goalCategory,
      ageGroup: ADULT_AGE_GROUP,
      timezone: veylData.timezone || 'GMT+0',
      matchPreference: veylData.matchPreference || 'nearby',
      blockedUsers: veylData.blockedUsers || [],
      name: veylData.name || null
    });

    return result.data.matched === true;

  } catch (error) {
    console.error('Error finding match:', error);
    return false;
  }
}

export async function createVeyl(userId, veylData) {
  try {
    const veylRef = await addDoc(collection(db, 'veyls'), {
      userId,
      goalCategory: veylData.goalCategory,
      goalDescription: veylData.goalDescription,
      timezone: veylData.timezone || 'GMT+0',
      communicationStyle: veylData.communicationStyle || null,
      matchPreference: veylData.matchPreference || 'nearby',
      ageGroup: ADULT_AGE_GROUP,
      avatarId: veylData.avatarId || null,
      status: 'seeking_partner',
      partnerId: null,
      partnerVeylId: null,
      messagesUsedToday: 0,
      voiceNotesUsedToday: 0,
      lastMessageReset: serverTimestamp(),
      goalAchieved: false,
      unveiled: false,
      unveiledAt: null,
      createdAt: serverTimestamp()
    });
    return { id: veylRef.id };
  } catch (error) {
    console.error('Error creating veyl:', error);
    throw error;
  }
}